import { personArtForm } from "../../../../../config/form/person/stamoplysninger/personArtFormConfig";
import { defaultPersonArtColumns } from "../../../../../config/person";
import {
  createColumnEditorTrigger,
  getHeaderActiveColumns,
  TD,
} from "../../../../../util/table";
import { tableToXLSX } from "../../../../../util/tableExportUtils";
import ButtonDownload from "../../../../ButtonDownload";
import ActiveIcon from "../../../../icons/ActiveIcon";
import { ModalProvider } from "../../../../Modal/Modal";
import {
  TableBody,
  TableHead,
  TableRoot,
  TableRow,
} from "../../../../Table/TableBasic";
import ColumnEditorModal from "@/components/column-editor/ColumnEditorModal";
import IngenRegistreringer from "../IngenRegistreringer";
import { PersonDto } from "../../../../../interfaces/schema";
import { PersonArtField } from "../../../../../interfaces/personer";
import { SortBy, IColumn } from "../../../../../interfaces/table";
import useLocalStorageState from "use-local-storage-state";
import { useContext } from "react";
import { UserQueryContext } from "../../../../../context/UserContext";
import { periodeIsActive } from "../../../../../util/date";
import { orderBy } from "../../../../../util/orderBy";
const defaultSortBy: SortBy[] = [
  {
    direction: "desc",
    field: "periode.tilDatoInklusiv",
  },
  {
    direction: "desc",
    field: "periode.fraDato",
  },
];
export default function PersonArt({
  columns,
  person,
  setActiveColumns,
}: {
  person: PersonDto;
  columns: IColumn<PersonArtField>[];
  setActiveColumns: React.Dispatch<React.SetStateAction<PersonArtField[]>>;
}) {
  const { user, hasPermission } = useContext(UserQueryContext);
  const isAuth = hasPermission(user, "BasisWrite");
  const [sortBy, setSortBy] = useLocalStorageState<SortBy[]>(
    "personEfteruddanelseSortBy",
    {
      defaultValue: defaultSortBy,
    },
  );

  if (!person.personPersonart?.length) return <IngenRegistreringer />;

  // event handlers
  function downloadHandler() {
    tableToXLSX(columns, person.personPersonart ?? [], {
      fileName: `personart-for-${person.kundeNr}`,
      additionalData: {
        kundenr: person.kundeNr,
      },
    });
  }

  return (
    <>
      <ButtonDownload onClick={downloadHandler} />
      <ModalProvider>
        <TableRoot>
          <TableHead ColumnEditorTrigger={createColumnEditorTrigger()}>
            <th className="indicator"></th>
            {getHeaderActiveColumns(columns, {
              defaultSortBy,
              setSortBy,
              sortBy,
            })}
          </TableHead>
          <TableBody>
            {orderBy(
              person.personPersonart,
              sortBy.map((s) => s.field),
              sortBy.map((s) => s.direction),
            ).map((personart) => {
              return (
                <TableRow
                  key={personart.personartNrNavigation?.navn}
                  editConfig={isAuth ? personArtForm : undefined}
                >
                  <td
                    className={`indicator ${
                      periodeIsActive(
                        new Date(personart.periode.fraDato),
                        new Date(personart.periode.tilDatoInklusiv),
                      )
                        ? " has-effect"
                        : ""
                    }  `}
                  >
                    <ActiveIcon />
                  </td>
                  {columns
                    .filter((col) => col.active)
                    .map((col) => {
                      return (
                        <TD key={col.field} col={col} rowData={personart} />
                      );
                    })}
                </TableRow>
              );
            })}
          </TableBody>
        </TableRoot>
        <ColumnEditorModal
          defaultColumns={defaultPersonArtColumns}
          columns={columns}
          setActiveColumns={setActiveColumns}
        />
      </ModalProvider>
    </>
  );
}
